import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./app.tsx";
import { QueryDefaults } from "./constants/query-defaults.ts";
import { storageKeys } from "./constants/storage-keys.ts";

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                retry: false,
                staleTime: QueryDefaults.StaleTime,
                throwOnError: (error) => {
                    // @ts-expect-error Potentially unsafe access
                    const status = error.status;
                    if (status == 401) {
                        localStorage.removeItem(storageKeys.Token);
                        sessionStorage.removeItem(storageKeys.Token);
                        window.location.reload();
                    }
                    return false;
                },
            },
        },
    });
    root.render(
        <StrictMode>
            <QueryClientProvider client={queryClient}>
                <App />
                <ReactQueryDevtools initialIsOpen={false} buttonPosition={"bottom-right"} />
            </QueryClientProvider>
        </StrictMode>,
    );
}
